import { useEffect, useState } from 'react';

export function BuildVersion() {
  const [buildInfo, setBuildInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadBuildInfo() {
      try {
        const response = await fetch(`/build-info.json?ts=${Date.now()}`, {
          cache: 'no-store',
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (!cancelled) {
          setBuildInfo(data);
        }
      } catch (_error) {
        // Build info is non-critical.
      }
    }

    loadBuildInfo();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!buildInfo) {
    return null;
  }

  const builtAt = buildInfo.builtAt
    ? new Date(buildInfo.builtAt).toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : null;

  return (
    <div className="mt-6 border-t border-neutral-200 pt-3 text-center text-xs text-neutral-500">
      <span>{buildInfo.appVersion ? `v${buildInfo.appVersion}` : 'version unknown'}</span>
      {buildInfo.gitBranch && <span> · {buildInfo.gitBranch}</span>}
      {buildInfo.gitSha && <span> · {buildInfo.gitSha}</span>}
      {builtAt && <span> · built {builtAt}</span>}
      {buildInfo.apiBaseUrl && (
        <span className="block sm:inline"> · API {buildInfo.apiBaseUrl}</span>
      )}
    </div>
  );
}
